import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { useTheme } from "@mui/material";

const EnrollSectionBoxStyles: React.FC<BoxProps> = ({ sx, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      id="enroll"
      py={8}
      bgcolor="#fff"
      borderRadius={7.5}
      sx={{
        display: "grid",
        placeItems: "center",
        boxShadow:
          "0px -3.3px 24px rgba(132, 132, 132, 0.16), inset 0px -2.51218px 6px rgba(0, 0, 0, 0.06)",
        width: 363,
        [theme.breakpoints.down("md")]: {
          zIndex: 1,
          boxShadow:
            "0px -3.3px 24px rgba(132, 132, 132, 0.16), inset 0px -2.51218px 6px rgba(0, 0, 0, 0.06)",
        },
        [theme.breakpoints.down("sm")]: {
          width: "99%",
        },
        ...(sx || {}),
      }}
      {...props}
    />
  );
};

export default EnrollSectionBoxStyles;
